<template>
    <div class="list-pagi-wrapper" v-if="numberOfPages > 1">
        <button class="pagi left" @click.prevent="handlePageChange(1)" :disabled="(page == 1)">
            |<
        </button>
        <button class="pagi middle"
            @click.prevent="handleForwardBackwardPageChange(-1)"
            :disabled="(page == 1)"
            :style="'padding: 0 5px;'"
        >
            <
        </button>
        <button v-for="n in pageRange"
            :key="n + '-idx'"
            @click.prevent="handlePageChange(n)"
            class="pagi middle"
            :class="{'selected-pagi': n==page}"
        >
            {{n}}
        </button>
        <button class="pagi middle"
            @click.prevent="handleForwardBackwardPageChange(1)"
            :disabled="(page == numberOfPages)"
        >
            >
        </button>
        <button class="pagi right"
            @click.prevent="handlePageChange(numberOfPages)"
            :disabled="(page == numberOfPages)"
        >
            >|
        </button>
    </div>
</template>

<script>
export default {
    name: "list-pagination",
    props: {
        mappingsPerPage: Number,
        targetList: Array
    },
    data() {
        return {
            page: 1
        };
    },
    watch: {
        paginatedMap: {
            handler: function(newValue) {
                this.$emit("results", newValue);
            }
        },
        targetList: {
            deep: true,
            handler: function(newValue, oldValue) {
                if (!_.isEqual(newValue, oldValue)) {
                    this.page = 1;
                }
            }
        }
    },
    computed: {
        mappingsPerPageValidated() {
            let v = parseInt(this.mappingsPerPage, 10);

            if (isNaN(v) || v < 1) {
                v = 1;
            }

            return v;
        },
        numberOfPages() {
            let n = Math.floor(
                (this.targetList.length + this.mappingsPerPageValidated - 1) /
                    this.mappingsPerPageValidated
            );

            if (n < 1) {
                n = 1;
            }

            return n;
        },
        paginatedMap() {
            //apply pagination
            let start =
                this.page * this.mappingsPerPageValidated -
                (this.mappingsPerPageValidated - 1) -
                1;

            let end =
                Math.min(
                    start + (this.mappingsPerPageValidated - 1),
                    this.targetList.length
                ) + 1;

            return this.targetList.slice(start, end);
        },
        pageRange() {
            let range = [];
            let min = Math.max(1, this.page - 2);
            let max = Math.min(this.numberOfPages, min + 4);

            for (let i = min; i <= max; i++) {
                range.push(i);
            }

            return range;
        }
    },
    mounted() {
        this.$emit("results", this.paginatedMap);
    },
    methods: {
        checkSelectedPageStillValid() {
            if (this.page > this.numberOfPages) {
                this.page = this.numberOfPages;
            }
            if (this.page < 1) {
                this.page = 1;
            }
        },
        handlePageChange(v) {
            this.$emit("change");
            this.page = v;
        },
        handleForwardBackwardPageChange(v) {
            this.$emit("change");
            this.page += v;
            this.checkSelectedPageStillValid();
        }
    }
};
</script>

<style lang="scss">
.list-pagi-wrapper {
    display: flex;
    justify-content: flex-end;
}
.pagi {
    height: 35px;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    border-width: 1px 0;
    border-style: solid;
    border-color: #cdd3e6;
    border-radius: 0;
    color: #1d4e7d;
    background: white;

    &.middle {
        min-width: 40px;
        border-left: 0;
        border-right: 1px;
        border-style: solid;
        border-color: #cdd3e6;
    }

    &.left {
        padding: 0 10px;
        border-left: 1px;
        border-right: 1px;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        border-style: solid;
        border-color: #cdd3e6;
    }

    &.right {
        padding: 0 10px;
        border-left: 0;
        border-right: 1px;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        border-style: solid;
        border-color: #cdd3e6;
    }
}
.pagi:enabled {
    cursor: pointer;
}
.pagi[disabled],
.pagi[disabled]:hover {
    color: #dedede;
    cursor: not-allowed;
}
.pagi:hover {
    background-color: #e7e9f2;
}
.selected-pagi {
    background-color: #396095;
    border-color: #396095;
    color: white;
}
.selected-pagi:hover {
    cursor: not-allowed;
    background-color: #396095;
}
</style>
